// Tim Hortons CSS

import { LayoutWidth, ZIndex } from './enums';

export default {
  // Extra CSS Properties
  borderRadius: '4px',
  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.1)',

  // Color Styles
  color: {
    accent: '#c90325',
    alert: {
      default: {
        background: '#76756d',
        text: '#ffffff'
      },
      info: {
        background: '#76756d',
        text: '#ffffff'
      },
      success: {
        background: '#572d2d',
        text: '#ffffff'
      },
      warning: {
        background: '#c41230',
        text: '#ffffff'
      },
      error: {
        background: '#c41230',
        text: '#ffffff'
      }
    },
    codeBlockBackground: '#323231',
    error: '#c41230',
    errorHover: '',
    pricing: '#c90325',
    validated: '#78a445',
    validatedHover: '',
    primary: '#C8102E',
    primaryHover: '#ac0c26',
    secondary: '#572d2d',
    secondaryHover: '',
    teal: '',
    tertiary: '#e4842b',
    navLinkColor: {
      active: '#fff',
      hover: '#fff'
    },
    mobileNavButtonColor: '#572d2d',
    background: '#fff',
    kioskBackground: '#f3efea',
    kioskKeyBorder: '#a1988d',
    kioskKeyBackground: '#dcd3c7',
    kioskKeyColor: '#3b3b3b',
    black: '#572d2d',
    grey: {
      one: '#76756d',
      two: '#896c6c',
      three: '#767676',
      four: '#dcdcdc',
      five: '#f5f1ef',
      six: '#f4f4f4',
      seven: '#ececec',
      eight: '#ececec',
      nine: ''
    },
    white: '#ffffff',
    headerContrast: '#fff',
    highlight: '',
    disabledBorder: '#f4e8ea',
    disabledBackground: '#fff6f7',
    disabledColor: '#ee9dab',
    success: ''
  },

  // Font Styles
  fontFamily: {
    base: '"sofia_pro", Helvetica, Arial, sans-serif',
    body: '"sofia_pro", Helvetica, Arial, sans-serif',
    alternative: '"sofia_pro", Helvetica, Arial, sans-serif',
    brand: '"greasepencil", Helvetica, Arial, sans-serif'
  },

  // Font Weight Styles
  fontWeight: {
    black: 800,
    heavy: 'bold',
    normal: 'normal',
    light: 300
  },

  // Font Transforms Styles
  textTransform: {
    headlines: 'none',
    body: 'none'
  },

  // Z Index Styles
  zIndex: {
    max: ZIndex.MAX,
    overlay: ZIndex.OVERLAY,
    top: ZIndex.TOP,
    normal: ZIndex.NORMAL,
    below: ZIndex.BELOW
  },

  // Layout variables
  layout: {
    sectionMaxWidth: `${LayoutWidth.REGULAR}px`,
    smallerSectionMaxWidth: `${LayoutWidth.SMALL}px`
  }
};
